/**
 * GA4 Ecommerce tracking utilities
 *
 * Provides helper functions for tracking ecommerce events in Google Analytics 4
 * and Google Ads remarketing. Events are only pushed if gtag is available
 * (i.e., when Google Analytics or Google Tag Manager is enabled).
 */

/**
 * Push a view_item event to the data layer for GA4 ecommerce tracking
 *
 * @param {Object} item - The item object with GA4 ecommerce fields
 * @param {string} item.item_id - Required: Product/property ID
 * @param {string} item.item_name - Required: Product/property name
 * @param {string} [item.item_brand] - Brand or agency name
 * @param {string} [item.item_category] - Product category
 * @param {string} [item.item_category2] - Product subcategory
 * @param {number} [item.price] - Item price
 * @param {number} [item.quantity] - Item quantity (defaults to 1)
 * @param {string} [currency='EUR'] - Currency code (ISO 4217)
 * @param {number} [value] - Total value (defaults to item price)
 */
export function pushViewItemEvent(item, currency = 'EUR', value = null) {
  // Only push event if gtag is available (GA or GTM is enabled)
  if (typeof window.gtag !== 'function') {
    return;
  }

  // Ensure required fields are present
  if (!item.item_id || !item.item_name) {
    console.warn('GA4 view_item event: item_id and item_name are required');
    return;
  }

  // Default quantity to 1 if not specified
  const itemData = {
    ...item,
    quantity: item.quantity || 1,
  };

  // Calculate value if not provided (use price * quantity)
  const eventValue = value !== null ? value : (item.price || 0) * (itemData.quantity || 1);

  // Push the view_item event following GA4 format
  window.gtag('event', 'view_item', {
    currency: currency,
    value: eventValue,
    items: [itemData]
  });
}
